export default "__VITE_ASSET__DzJeSGwd__"